module.exports = __webpack_public_path__ + "img/36_46.fce302fa.png";